import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { AbstractWSOutputVO } from 'src/app/commun/vo/AbstractWSOutputVO';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GenericHttpClient {

    constructor(private http: HttpClient) { }

    public httpOptions = {
        withCredentials: true,
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    httpGet(url: string): Observable<Object> {
        return this.http.get(url, this.httpOptions).pipe(timeout(environment.TIMEOUT),
            catchError(e => {
                const timeoutResult = new AbstractWSOutputVO();
                timeoutResult.listErrorMsgs.push('Timeout  ...');
                return of(timeoutResult);
            }));
    }

    httpPost(url: string, body: any) {
        return this.http.post(url, body, this.httpOptions).pipe(timeout(environment.TIMEOUT),
            catchError(e => {
                const timeoutResult = new AbstractWSOutputVO();
                timeoutResult.listErrorMsgs.push('Timeout  ...');
                return of(timeoutResult);
            }));
    }

    httpPut(url: string, body: any) {
        return this.http.put(url, body, this.httpOptions).pipe(timeout(environment.TIMEOUT),
            catchError(e => {
                const timeoutResult = new AbstractWSOutputVO();
                timeoutResult.listErrorMsgs.push('Timeout ...');
                return of(timeoutResult);
            }));
    }

    httpDelete(url: string) {
        return this.http.delete(url, this.httpOptions).pipe(timeout(environment.TIMEOUT),
            catchError(e => {
                const timeoutResult = new AbstractWSOutputVO();
                timeoutResult.listErrorMsgs.push('Timeout  ...');
                return of(timeoutResult);
            }));
    }
}
